import loadTableViewFromTableQuery from './loadTableViewFromTableQuery';
import { getDefaultInboxTableQuery } from 'owa-mail-triage-table-utils/lib/getDefaultInboxTableQueries';
import type { SessionData } from 'owa-service/lib/types/SessionData';
import type { MailboxInfo } from 'owa-client-types';
import { Module } from 'owa-workloads-module';
import { registerLoadDefaultTable } from 'owa-mailhandling-option';

// Function that loads the default table view.
export function loadDefaultTable(mailboxInfo: MailboxInfo, sessionData?: SessionData) {
    // Load default inbox table
    loadTableViewFromTableQuery(
        getDefaultInboxTableQuery(mailboxInfo),
        undefined /* loadTableViewDatapoint */,
        undefined /* actionSource */,
        sessionData,
        Module.Mail
    );
}

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function registerLoadDefaultTable called at module scope is not allowed. This may cause unwanted side effects. */
registerLoadDefaultTable(loadDefaultTable);
